import { useMemo } from 'react';

import { AssignmentLevelsResult, calculateAssignmentLevels } from '../../helpers';
import { AssignmentType } from '../../types';

export const useAssignmentLevels = (assignments: AssignmentType[]): AssignmentLevelsResult => {
  return useMemo(() => calculateAssignmentLevels(assignments), [assignments]);
};
